import React from 'react';
import { useMenu } from 'hooks';
import {
	Box,
	Checkbox,
	IconButton,
	Menu,
	MenuItem,
	TableCell,
	TableRow,
	Typography
} from '@mui/material';
import { Image } from 'components';
import { MoreHoriz } from '@mui/icons-material';

const ClubItem = ({
	club,
	isSelectable,
	selectedIds = [],
	handleSelect,
	handleClick,
	handleEditClick,
	handleDeleteClick,
	...props
}) => {
	const { open, anchorEl, handleToggleMenu, handleClose } = useMenu();

	const renderMenu = () => (
		<Menu open={open} onClose={handleClose} anchorEl={anchorEl}>
			<MenuItem onClick={(e) => handleEditClick(club, e)}>Edit</MenuItem>
			<MenuItem onClick={(e) => handleDeleteClick(club, e)}>Delete</MenuItem>
		</Menu>
	);

	const isSelected = selectedIds.includes(club.id);

	return (
		<TableRow
			hover
			onClick={() => handleClick(club)}
			sx={{ cursor: 'pointer' }}
		>
			{isSelectable && (
				<TableCell>
					<Checkbox
						checked={isSelected ? true : false}
						onChange={() => handleSelect(club)}
						name="club"
						color="primary"
					/>
				</TableCell>
			)}
			<TableCell>
				<Image src={club.image_url} variant="rounded" size={80} />
			</TableCell>
			<TableCell>
				<Typography variant="body2">{club.name}</Typography>
			</TableCell>
			<TableCell>
				<Typography variant="body2">{club.city}</Typography>
			</TableCell>
			<TableCell>
				<Typography variant="body2">{club.country}</Typography>
			</TableCell>
			<TableCell align="right">
				<IconButton
					onClick={(e) => {
						e.stopPropagation();
						handleToggleMenu(e);
					}}
				>
					<MoreHoriz />
				</IconButton>
				{renderMenu()}
			</TableCell>
		</TableRow>
	);
};

export default ClubItem;
